import { Utils } from "src/modules/utils/shared/utils";
import { ComponentView } from "./component-view.model";

export class SaveDataHandler {
    worker: () => Promise<any>;
    componentView: ComponentView;
    successToast = false;
    navigateBack = false;
    navigateTo: string[] = [];
    successTitle: string = null;
    successText: string = null;
    
    constructor(options: Partial<SaveDataHandler>) {
        if (options != null) {
            Object.assign(this, options);
        }
    }

}